import { render } from "./YouryFormInput.vue?vue&type=template&id=eb2f4404"
import script from "./YouryFormInput.vue?vue&type=script&lang=js"
export * from "./YouryFormInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/youry.co/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__